export function getPreviousDay(daysQnt?: number) {
  const today = new Date();
  const previousDay = new Date(today);
  previousDay.setDate(today.getDate() - (daysQnt ?? 1));
  return previousDay;
}